<div aria-label="Button group with nested dropdown" class="btn-group" container="body" ngbDropdown role="group">
  <button class="btn btn-link float-right dropdown-no-arrow" ngbDropdownToggle title="Toggle Actions Dropdown">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button (click)="onRemoveApiConfig()"
      [ngClass]="{'text-danger': !deleteButtonIsDisabled}"
      [disabled]="deleteButtonIsDisabled"
      ngbDropdownItem>
      <span class="fa-solid fa-trash"></span>
      <span translate>Delete</span></button>
      <button (click)="onEditApiEndpoint()" [disabled]="!superOrTechAdmin" ngbDropdownItem>
        <span class="fa-solid fa-pen"></span>
        <span translate>Edit</span>
      </button>
      @if (!endpointIsActive) {
        <button (click)="onActivateEndpoint()" [disabled]="!superOrTechAdmin"
          ngbDropdownItem>
          <span class="fa-solid fa-play"></span>
          <span translate>Activate</span>
        </button>
      }
      @if (endpointIsActive) {
        <button (click)="onDeactivateEndpoint()" [disabled]="!superOrTechAdmin"
          ngbDropdownItem>
          <span class="fa-solid fa-pause"></span>
          <span translate>Deactivate</span>
        </button>
      }
    </div>
  </div>
